// import React from "react";

// export default function Lucky15() {
//     return (
//         <div className="modal-dialog modal-xl">
//             <div className="modal-content">
//                 <div className="modal-header">
//                     <div className="modal-title h4">Result</div>
//                     <button type="button" className="btn-close" aria-label="Close" />
//                 </div>
//                 <div className="modal-body">
//                     <div className="casino-result-modal">
//                         <div className="casino-result-round-id">
//                             <span>
//                                 <b>Round Id: </b> 161250517155023
//                             </span>
//                             <span>
//                                 <b>Match Time: </b>17/05/2025 15:50:23
//                             </span>
//                         </div>
//                         <div className="row mt-2">
//                             <div className="text-center">
//                                 <div className="cricket20ballpopup cricket20ballresult">
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/balls/ball-blank.png" />
//                                     <span>1 Run</span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>

//     );
// }

import React from "react";

export default function Lucky15({ data }) {
  const casinoResult = data?.casinoIndividualResultDTO;

  if (!casinoResult) {
    return <div>No data available</div>;
  }  

  // Helper function to generate card image URLs
  const getCardImage = (card) =>
    `https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/${card}.png`;

return (
  <div className="modal-body">
    <div className="casino-result-modal">
      {/* Round ID and Match Time */}
      <div className="casino-result-round-id">
        <span>
          <b>Round Id: </b> {casinoResult.marketId}  
        </span>
        <span>
          <b>Match Time: </b>{" "}
          {new Date(casinoResult.createdAt + "Z").toLocaleString()}
        </span>
      </div>

      {/* Cards */}
      <div className="row mt-2">
        <div className="col-md-12 text-center">
          <div className="casino-result-cards">
            {casinoResult.casinoCardResultMaps[0]?.result.map(
              (card, index) => (
                <img
                  key={index}
                  src={getCardImage(card)}
                  alt={`Card ${index}`}
                />
              )
            )}
          </div>
        </div>
      </div>

      {/* Result Descriptions on Ball */}
      <div className="row mt-2 justify-content-center">
        <div className="col-md-6">
          {/* Container relative for positioning */}
          <div
            style={{
              position: "relative",
              width: "150px",
              height: "150px",
              margin: "0 auto"
            }}
          >
            {/* Ball image */}
            <img
              src="https://g1ver.sprintstaticdata.com/v53/static/front/img/balls/ball-blank.png"
              alt="Ball Background"
              style={{ width: "100%", height: "100%" }}
            />

            {/* Text overlay */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                textAlign: "center",
                fontWeight: "bold",
                pointerEvents: "none",
                padding: "10px",
                userSelect: "none"
              }}
            >
              {casinoResult.casinoIndividualResultMaps.map((result) => (
                <div key={result.id}>
                  {/* <div>{result.resultFor}</div> */}
                  <div>{result.result[0]}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
}